import { db } from './Database';
import { StackTestLayoutService } from './StackTestLayoutService';
export class OfflineProjectService {
    static async saveProjectOffline(projectData: any) {
        try {
            await db.transaction('rw', [
                db.projects,
                db.newFailureModes,
                db.shippingModes,
                db.postShipTruckTestLayouts,
                db.pallets,
                db.primaryPackagingDetails,
                db.secondaryPackagingDetails,
                db.palletShippingModes,
                db.tertiaryPackagingDetails,
                db.palletDetails,
                db.unitLoadDetails,
                db.palletizingRecipes,
                db.palletLpnNumbers,
                db.leans,
                db.ftlRows,
                db.unitLoadPositions,
                db.unitLoadHeights,
                db.rqls,
                db.rqlDefects
            ], async () => {
                // Save project
                const projectId = await db.projects.put({
                    id: projectData.id,
                    projectName: projectData.projectName,
                    projectDescription: projectData.projectDescription,
                    createdBy: projectData.createdBy,
                    target: projectData.target,
                    percentage: projectData.percentage,
                    plusByUser: projectData.plusByUser,
                    overallDecision: projectData.overallDecision,
                    createdAt: projectData.createdAt,
                    updatedAt: projectData.updatedAt,
                    reasonForInvalidStackingTest: projectData.reasonForInvalidStackingTest,
                    validStackingTest: projectData.validStackingTest,
                    overallDecisionFailureNote: projectData.overallDecisionFailureNote,
                    offlineMetadata: {
                        downloadedAt: new Date().toISOString(),
                        onlineId: projectData.id,
                        status: 'downloaded',
                        syncStatus: 'pending'
                    }
                });
                // Save failure modes
                if (projectData.newFailureModes?.length) {
                    
                    await Promise.all(projectData.newFailureModes?.map(async (mode: any) => {
                        await db.newFailureModes.where('projectId').anyOf(projectId).delete()
                        await db.newFailureModes.put({
                            ...mode,
                            projectId
                        });
                    }));
                }
                // Save shipping modes
                if (projectData.shippingModes?.length) {
                    await Promise.all(projectData.shippingModes?.map(async (mode: any) => {
                        await db.shippingModes.put({
                            ...mode,
                            projectId
                        });
                        if (mode.postShipTruckTestLayouts?.length) {
                            await Promise.all(mode.postShipTruckTestLayouts?.map(async (layout: any) => {
                                await db.postShipTruckTestLayouts.put({
                                    ...layout,
                                    // shippingModeId:mode.id
                                })
                            }))
                        }
                    }));
                }

                // Save pallets and related data
                console.log(projectData.pallets, 'projectData.pallets')
                if (projectData.pallets?.length) {

                    await Promise.all(projectData.pallets?.map(async (pallet: any) => {
                        const palletId = await db.pallets.put({
                            ...pallet,
                            projectId
                        });
                        console.log(palletId, 'palletId')
                        // Save packaging details
                        console.log(pallet.palletShippingModes, 'pallet.palletShippingModes')
                        await Promise.all(pallet.palletShippingModes?.map(async (psm: any) => {
                            await db.palletShippingModes.put({
                                ...psm,
                            })
                        }))
                        // await db.palletShippingModes.bulkPut(pallet.palletShippingModes?.map((psm:any)=>{
                        //     if(psm.createdAt){
                        //         delete psm.createdAt

                        //     }
                        //     if(psm.updatedAt){
                        //         delete psm.updatedAt
                        //     }
                        //     return {
                        //         ...psm,
                        //         palletId
                        //     }
                        // }))
                        console.log(pallet.palletizingRecipe)
                        await Promise.all([
                            this.savePrimaryPackaging(pallet.primaryPackagingDetails, palletId),
                            this.saveSecondaryPackaging(pallet.secondaryPackagingDetails, palletId),
                            this.saveTertiaryPackaging(pallet.tertiaryPackagingDetails, palletId),
                            this.savePalletDetails(pallet.palletDetails, palletId),
                            this.saveUnitLoadDetails(pallet.unitLoadDetails, palletId),
                            this.savePalletizingRecipe(pallet.palletizingRecipe, palletId),
                            this.saveLpnNumbers(pallet.lpnNumbers, palletId),
                            this.saveRQLData(pallet.rqls, palletId)
                        ]);
                    }));
                }
            });

            return true;
        } catch (error) {
            console.error('Error saving project offline:', error);
            throw error;
        }
    }

    private static async savePrimaryPackaging(details: any[], palletId: number) {
        if (details?.length) {
            await db.primaryPackagingDetails.put(
                details[0]
            );
        }
    }

    private static async saveSecondaryPackaging(details: any[], palletId: number) {
        if (details?.length) {
            await db.secondaryPackagingDetails.put(
                details[0]
            );
        }
    }

    private static async saveTertiaryPackaging(details: any[], palletId: number) {
        if (details?.length) {
            await db.tertiaryPackagingDetails.put(
                details[0]
            );
        }
    }

    private static async savePalletDetails(details: any[], palletId: number) {
        if (details?.length) {
            await db.palletDetails.put(
                details[0]
            );
        }
    }

    private static async saveUnitLoadDetails(details: any[], palletId: number) {
        if (details?.length) {
            await db.unitLoadDetails.put(
                details[0]
            );
        }
    }

    private static async savePalletizingRecipe(recipes: any[], palletId: number) {
        if (recipes?.length) {
            await db.palletizingRecipes.put(
                recipes[0]
            );
        }
    }

    private static async saveLpnNumbers(lpnNumbers: any[], palletId: number) {
        if (lpnNumbers?.length) {
                await Promise.all(lpnNumbers?.map(async (lpn) => {
                const lpnId = await db.palletLpnNumbers.put({
                    ...lpn,
                    palletId
                });

                await Promise.all([
                    this.saveLeans(lpn.leans, lpnId),
                    this.saveFTLRows(lpn.ftlRows, lpnId),
                    this.saveUnitLoadPositions(lpn.unitLoadPositions, lpnId),
                    this.saveUnitLoadHeights(lpn.unitLoadHeights, lpnId)
                ]);
            }));
        }
    }

    private static async saveLeans(leans: any[], lpnId: number) {
        if (leans?.length) {
            await db.leans.bulkPut(
                leans?.map(lean => ({ ...lean, palletLpnNumberId: lpnId }))
            );
        }
    }

    private static async saveFTLRows(rows: any[], lpnId: number) {
        if (rows?.length) {
            await db.ftlRows.bulkPut(
                rows?.map(row => ({ ...row, palletLpnNumberId: lpnId }))
            );
        }
    }

    private static async saveUnitLoadPositions(positions: any[], lpnId: number) {
        if (positions?.length) {
            await db.unitLoadPositions.bulkPut(
                positions?.map(pos => ({ ...pos, palletLpnNumberId: lpnId }))
            );
        }
    }

    private static async saveUnitLoadHeights(heights: any[], lpnId: number) {
        if (heights?.length) {
            await db.unitLoadHeights.bulkPut(
                heights?.map(height => ({ ...height, palletLpnNumberId: lpnId }))
            );
        }
    }

    private static async saveRQLData(rqls: any[], palletId: number) {
        if (rqls?.length) {
            // Group RQLs by variant
            const rqlsByVariant = rqls.reduce((acc: { [key: string]: any }, rql: any) => {
                const variant = rql.rqlData.variant;
                if (!acc[variant]) {
                    // Use the first RQL data as the base
                    acc[variant] = {
                        rqlData: rql.rqlData,
                        rqlDefects: []
                    };
                }
                // Merge defects from all RQLs of the same variant
                if (rql.rqlDefects?.length) {
                    acc[variant].rqlDefects.push(...rql.rqlDefects);
                }
                return acc;
            }, {});

            // Save each consolidated RQL
            await Promise.all(Object.values(rqlsByVariant)?.map(async (consolidatedRql: any) => {
                const rqlData = consolidatedRql.rqlData;
                const rqlDefects = consolidatedRql.rqlDefects;

                // Ensure dateOfInspection is a valid ISO string or null
                let dateOfInspection = null;
                try {
                    if (rqlData.dateOfInspection) {
                        const date = new Date(rqlData.dateOfInspection);
                        if (!isNaN(date.getTime())) {
                            dateOfInspection = date.toISOString();
                        }
                    }
                } catch (error) {
                    console.error('Invalid date format:', error);
                }

                // Save RQL data
                const rqlId = await db.rqls.put({
                    ...rqlData,
                    dateOfInspection,
                    palletId
                });

                // Save RQL defects
                if (rqlDefects?.length) {
                    // Remove duplicate defects based on defectKeyId
                    const uniqueDefects = rqlDefects.reduce((acc: any[], defect: any) => {
                        const existingDefect = acc.find(d => d.defectKeyId === defect.defectKeyId);
                        if (!existingDefect) {
                            acc.push(defect);
                        }
                        return acc;
                    }, []);

                    await db.rqlDefects.bulkPut(
                        uniqueDefects?.map((defect: any) => ({
                            ...defect,
                            rqlId,
                            defectKeyId: defect.defectKeyId,
                            defectType: defect.defectType,
                            defectPercentage: defect.defectPercentage
                        }))
                    );
                }
            }));
        }
    }

    static async getProjectDataForUpload(projectId: number, selectedSections: string[]) {
        try {
            const project = await db.projects.get(projectId);
            if (!project) throw new Error('Project not found');
            console.log(project, 'projectttt')
            const data: any = {
                projectDetails: {
                    projectName: project.projectName,
                    projectDescription: project.projectDescription,
                    createdBy: project.createdBy,
                    target: project.target,
                    percentage: project.percentage,
                    plusByUser: project.plusByUser,
                    overallDecision: project.overallDecision
                }
            };
            if (selectedSections.includes('define')) {
                const shippingModes = await db.shippingModes
                    .where('projectId')
                    .equals(projectId)
                    .toArray();
                data.shippingModes = shippingModes;
            }
            // Issue 1: We're not handling the case where pallets are needed for multiple sections
            // Solution: We should fetch pallets once if any section needs them
            const needsPallets = ['palletConfig', 'lpnNumber', 'preShip', 'postShip', "postStack", 'rql'].some(
                section => selectedSections.includes(section)
            );

            if (needsPallets) {
                const pallets = await db.pallets.where('projectId').equals(projectId).toArray();
                data.pallets = await Promise.all(pallets?.map(async (pallet) => {
                    const palletData: any = { ...pallet };

                    if (selectedSections.includes('palletConfig')) {
                        palletData.primaryPackagingDetails = await db.primaryPackagingDetails
                            .where('palletId').equals(pallet.id!).toArray();
                        palletData.secondaryPackagingDetails = await db.secondaryPackagingDetails
                            .where('palletId').equals(pallet.id!).toArray();
                        palletData.tertiaryPackagingDetails = await db.tertiaryPackagingDetails
                            .where('palletId').equals(pallet.id!).toArray();
                        palletData.palletDetails = await db.palletDetails
                            .where('palletId').equals(pallet.id!).toArray();
                        palletData.unitLoadDetails = await db.unitLoadDetails
                            .where('palletId').equals(pallet.id!).toArray();
                        palletData.palletizingRecipes = await db.palletizingRecipes
                            .where('palletId').equals(pallet.id!).toArray();
                    }

                    if (selectedSections.includes('lpnNumber') ||
                        selectedSections.includes('preShip') ||
                        selectedSections.includes('postShip') ||
                        selectedSections.includes('postStack')) {
                        const lpnNumbers = await db.palletLpnNumbers
                            .where('palletId').equals(pallet.id!).toArray();

                        palletData.lpnNumbers = await Promise.all(lpnNumbers?.map(async (lpn) => {
                            const lpnData: any = { ...lpn };

                            if (selectedSections.includes('preShip') ||
                                selectedSections.includes('postShip') ||
                                selectedSections.includes('postStack')) {
                                lpnData.leans = await db.leans
                                    .where('palletLpnNumberId').equals(lpn.id!).toArray();
                                lpnData.ftlRows = await db.ftlRows
                                    .where('palletLpnNumberId').equals(lpn.id!).toArray();
                                lpnData.unitLoadPositions = await db.unitLoadPositions
                                    .where('palletLpnNumberId').equals(lpn.id!).toArray();
                                lpnData.unitLoadHeights = await db.unitLoadHeights
                                    .where('palletLpnNumberId').equals(lpn.id!).toArray();
                            }

                            return lpnData;
                        }));
                    }

                    if (selectedSections.includes('postStack') ||
                        selectedSections.includes('preShip') ||
                        selectedSections.includes('postShip')) {
                        // Get all RQLs for this pallet
                        const rqls = await db.rqls.where('palletId').equals(pallet.id!).toArray();

                        // Group RQLs by variant
                        const rqlsByVariant = rqls.reduce((acc: { [key: string]: any }, rql: any) => {
                            if (!acc[rql.variant]) {
                                acc[rql.variant] = rql;
                                acc[rql.variant].defects = [];
                            }
                            return acc;
                        }, {});

                        // Get defects for each RQL and add them to the corresponding variant
                        await Promise.all(rqls?.map(async (rql) => {
                            const defects = await db.rqlDefects.where('rqlId').equals(rql.id!).toArray();
                            if (defects.length > 0) {
                                rqlsByVariant[rql.variant].defects.push(...defects);
                            }
                        }));

                        // Convert the grouped RQLs to the required format
                        palletData.rqls = Object.values(rqlsByVariant)?.map((rql: any) => {
                            // Remove duplicate defects based on defectKeyId
                            const uniqueDefects = rql.defects.reduce((acc: any[], defect: any) => {
                                const existingDefect = acc.find(d => d.defectKeyId === defect.defectKeyId);
                                if (!existingDefect) {
                                    acc.push(defect);
                                }
                                return acc;
                            }, []);

                            return {
                                rqlData: {
                                    id: rql.id,
                                    packageType: rql.packageType,
                                    palletId: rql.palletId,
                                    variant: rql.variant,
                                    targetSampleSize: rql.targetSampleSize,
                                    actualSampleSize: rql.actualSampleSize,
                                    dateOfInspection: (() => {
                                        try {
                                            if (rql.dateOfInspection) {
                                                const date = new Date(rql.dateOfInspection);
                                                return !isNaN(date.getTime()) ? date.toISOString() : null;
                                            }
                                            return null;
                                        } catch (error) {
                                            console.error('Invalid date format:', error);
                                            return null;
                                        }
                                    })(),
                                    inspectedBy: rql.inspectedBy,
                                    totalDefects: rql.totalDefects,
                                    percentDefects: rql.percentDefects,
                                    passFail: rql.passFail,
                                    unclassifiedDefects: rql.unclassifiedDefects,
                                    rqlNotes: rql.rqlNotes,
                                    isOnline: rql.isOnline,
                                    onlineId: rql.onlineId
                                },
                                rqlDefects: uniqueDefects?.map(defect => ({
                                    defectKeyId: defect.defectKeyId,
                                    defectType: defect.defectType,
                                    defectPercentage: defect.defectPercentage,
                                    isOnline: defect.isOnline,
                                    onlineId: defect.onlineId
                                }))
                            };
                        });
                    }

                    return palletData;
                }));
            }

            if (selectedSections.includes('truckLayout')) {
                const shippingModes = await db.shippingModes
                    .where('projectId').equals(projectId).toArray();
                data.shippingModes = await Promise.all(shippingModes?.map(async (mode) => ({
                    ...mode,
                    postShipTruckTestLayouts: await db.postShipTruckTestLayouts
                        .where('shippingModeId').equals(mode.id!).toArray()
                })));
            }
            if (selectedSections.includes('stackTestLayout')) {
                const pallets = await StackTestLayoutService.getPalletsForTestStack(projectId)
                data.palletsForTestStack = pallets
            }
            if (selectedSections.includes('synopsis')) {
                const project = await db.projects.get(projectId)
                data.synopsis = { projectName: project?.projectName, projectDescription: project?.projectDescription, overallDecision: project?.overallDecision, overallDecisionFailureNote: project?.overallDecisionFailureNote, validStackingTest: project?.validStackingTest, reasonForInvalidStackingTest: project?.reasonForInvalidStackingTest }
                const newFailureModes = await db.newFailureModes.where('projectId').equals(projectId).toArray()
                data.newFailureModes = newFailureModes
            }
            return data;
        } catch (error) {
            console.error('Error getting project data for upload:', error);
            throw error;
        }
    }

    static async updateOfflineProject(projectId: number, onlineData: any) {
        try {
            await db.transaction('rw', [
                db.projects,
                db.shippingModes,
                db.pallets,
                db.primaryPackagingDetails,
                db.secondaryPackagingDetails,
                db.tertiaryPackagingDetails,
                db.palletDetails,
                db.unitLoadDetails,
                db.palletizingRecipes,
                db.palletLpnNumbers,
                db.leans,
                db.ftlRows,
                db.unitLoadPositions,
                db.unitLoadHeights,
                db.rqls,
                db.rqlDefects
            ], async () => {
                const project = await db.projects.get(projectId);
                if (!project) throw new Error('Project not found');

                // Update project with new online data while preserving offline metadata
                await db.projects.put({
                    ...onlineData,
                    offlineMetadata: {
                        ...project.offlineMetadata,
                        lastSyncedAt: new Date().toISOString()
                    }
                });
            });
        } catch (error) {
            console.error('Error updating offline project:', error);
            throw error;
        }
    }

    static async deleteProject(projectId: number) {
        try {
            await db.transaction('rw', [
                db.projects,
                db.newFailureModes,
                db.shippingModes,
                db.postShipTruckTestLayouts,
                db.pallets,
                db.primaryPackagingDetails,
                db.secondaryPackagingDetails,
                db.palletShippingModes,
                db.tertiaryPackagingDetails,
                db.palletDetails,
                db.unitLoadDetails,
                db.palletizingRecipes,
                db.palletLpnNumbers,
                db.leans,
                db.ftlRows,
                db.unitLoadPositions,
                db.unitLoadHeights,
                db.rqls,
                db.rqlDefects
            ], async () => {
                // First, get all pallets for this project to get their IDs
                const pallets = await db.pallets.where('projectId').equals(projectId).toArray();
                const palletIds = pallets?.map(p => p.id!);

                // Get all LPN numbers for these pallets
                const lpnNumbers = await db.palletLpnNumbers
                    .where('palletId')
                    .anyOf(palletIds)
                    .toArray();
                const lpnIds = lpnNumbers?.map(lpn => lpn.id!);

                // Get all RQLs for these pallets
                const rqls = await db.rqls
                    .where('palletId')
                    .anyOf(palletIds)
                    .toArray();
                const rqlIds = rqls?.map(rql => rql.id!);

                // Delete all related data in reverse order of dependencies
                await Promise.all([
                    // Delete LPN related data
                    db.leans.where('palletLpnNumberId').anyOf(lpnIds).delete(),
                    db.ftlRows.where('palletLpnNumberId').anyOf(lpnIds).delete(),
                    db.unitLoadPositions.where('palletLpnNumberId').anyOf(lpnIds).delete(),
                    db.unitLoadHeights.where('palletLpnNumberId').anyOf(lpnIds).delete(),

                    // Delete RQL related data
                    db.rqlDefects.where('rqlId').anyOf(rqlIds).delete(),

                    // Delete pallet related data
                    db.primaryPackagingDetails.where('palletId').anyOf(palletIds).delete(),
                    db.secondaryPackagingDetails.where('palletId').anyOf(palletIds).delete(),
                    db.tertiaryPackagingDetails.where('palletId').anyOf(palletIds).delete(),
                    db.palletDetails.where('palletId').anyOf(palletIds).delete(),
                    db.unitLoadDetails.where('palletId').anyOf(palletIds).delete(),
                    db.palletizingRecipes.where('palletId').anyOf(palletIds).delete(),
                    db.palletShippingModes.where('palletId').anyOf(palletIds).delete(),
                ]);

                // Delete main entities
                await Promise.all([
                    db.rqls.where('palletId').anyOf(palletIds).delete(),
                    db.palletLpnNumbers.where('palletId').anyOf(palletIds).delete(),
                ]);

                // Delete pallets
                await db.pallets.where('projectId').equals(projectId).delete();

                // Delete project-level data
                await Promise.all([
                    db.newFailureModes.where('projectId').equals(projectId).delete(),
                    db.shippingModes.where('projectId').equals(projectId).delete(),
                ]);

                // Finally delete the project itself
                await db.projects.delete(projectId);
            });
        } catch (error) {
            console.error('Error deleting project:', error);
            throw error;
        }
    }
}
